
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CountrySelectionService } from './country-selection.service';
import { map, switchMap } from 'rxjs/operators';
import { CsrfService } from './csrf.service';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  constructor(private http: HttpClient, private countrySelectionService: CountrySelectionService, private csrfService: CsrfService) { }

  getComments(nid: any): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('get_user_comments', country);
        return this.http.get<any[]>(apiUrl).pipe(
          map(comments => comments.filter(comment => comment.entity_id === nid))
        );
      })
    );
  }

  postComment(comment: any): Observable<any> {
    const body = {
      ...comment,
      nid: Number(comment.nid)
    };
    return this.csrfService.getCsrfToken().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'X-CSRF-Token': token
        });
        return this.countrySelectionService.selectedCountry$.pipe(
          switchMap(country => {
            const apiUrl = this.countrySelectionService.getApiUrl('post_comment', country);
            return this.http.post(apiUrl, body, { headers });
          })
        );
      })
    );
  }
}
